
import React, { useContext } from "react";
import { FaHardHat, FaShieldAlt, FaUserMd, FaCheckCircle } from 'react-icons/fa';
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import './ConsultancyGlobal.css';
import BannerImage from './consultancy_hero.png';

function ISO45001Cons() {
  const navigate = useNavigate();
  const { isAuthenticated } = useContext(AuthContext);

  const handleBooking = () => {
    if (isAuthenticated) {
      navigate('/booking/iso-45001-consultancy');
    } else {
      navigate('/login', { state: { from: '/booking/iso-45001-consultancy' } });
    }
  };

  return (
    <div className="consultancy-page">
      <div className="consultancy-max-width">

        {/* --- HERO --- */}
        <div className="consultancy-hero" style={{ backgroundImage: `url(${BannerImage})` }}>
          <span className="hero-tag">Health & Safety</span>
          <h1 className="hero-title">ISO 45001 Consultation</h1>
          <p className="hero-subtitle">
            Creating a safer workplace. The international standard for reducing occupational injuries
            and diseases.
          </p>
          <button onClick={handleBooking} className="btn-hero">
            Get Consulted <span style={{ fontSize: '1.2em' }}>→</span>
          </button>
        </div>

        {/* --- CONTENT --- */}
        <div className="detail-content">

          <div className="content-article">
            <div className="article-section">
              <h2 className="article-heading">Safety First, Always</h2>
              <p className="article-text">
                ISO 45001 provides a robust framework for managing OH&S risks and opportunities.
                It helps you protect your most valuable asset—your people—by proactively identifying hazards
                rather than reacting to accidents.
              </p>
            </div>

            <div className="article-section">
              <h2 className="article-heading">Customized Integration</h2>
              <p className="article-text">
                Safety isn't one-size-fits-all. We tailor the standard to your specific industry risks,
                whether you are in construction, manufacturing, or corporate services. We ensure the system
                is practical, usable, and compliant.
              </p>
            </div>

            <div className="article-section">
              <h2 className="article-heading">The Path to Certification</h2>
              <p className="article-text">
                We assist with Hazard Identification (HIRA), Legal Register creation, Emergency Preparedness plans,
                and Internal Audits. Our goal is 100% readiness for your certification audit.
              </p>
            </div>
          </div>

          {/* --- SIDEBAR --- */}
          <div className="content-sidebar">
            <div className="sidebar-widget">
              <h4 className="widget-title">Why Certify?</h4>
              <ul className="key-list">
                <li><FaShieldAlt className="check-icon" /> Reduced Incidents</li>
                <li><FaUserMd className="check-icon" /> Better Employee Morale</li>
                <li><FaHardHat className="check-icon" /> Legal Protection</li>
                <li><FaCheckCircle className="check-icon" /> Global Credibility</li>
              </ul>
            </div>

            <div className="sidebar-widget" style={{ background: 'linear-gradient(135deg, #111 0%, #222 100%)', border: '1px solid #333' }}>
              <h4 className="widget-title">Make Safety Priority</h4>
              <p style={{ color: '#ccc', marginBottom: '20px', fontSize: '0.9rem' }}>
                Achieve ISO 45001 standards.
              </p>

              <button
                onClick={handleBooking}
                className="btn-primary"
                style={{ width: '100%', justifyContent: 'center' }}
              >
                Book Now
              </button>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}

export default ISO45001Cons;
